import React from 'react';
import styled from 'styled-components';

import { ConciergeNavButton } from 'src/dispensary/core-menu/components/header/concierge-nav-button';

type ConciergeEntryBannerProps = {
  cName: string | null;
};

/**
 * Full-width concierge entry point rendered directly under the header on
 * embedded (iframe) menus at the same breakpoint where the header's own
 * ConciergeNavButton pill is hidden (MobileHeader, <880px) — ECOMM-12462.
 *
 * This exists because the FAB (the entry point that previously covered this
 * gap) was pulled from embedded menus entirely: a fixed-position floating
 * button doesn't behave reliably inside an auto-resized, host-page-controlled
 * iframe (see ECOMM-12299/ECOMM-12301). Product's replacement design is this
 * banner — same visual identity as the header's pill (reuses
 * ConciergeNavButton itself, same shimmer/glow animations, same click
 * handling), just stretched to fill the width of the header instead of
 * hugging its own content.
 *
 * Reuses ConciergeNavButton directly rather than re-implementing its effects:
 * the shimmer/glow SVG strokes are already measured off the button's real
 * rendered size via ResizeObserver (see useButtonMetrics in
 * concierge-button-effects.ts), so `fullWidth` doesn't require any changes
 * there — they adapt automatically to the new width.
 */
export function ConciergeEntryBanner({ cName }: ConciergeEntryBannerProps): JSX.Element | null {
  if (!cName) return null;

  return (
    <Banner>
      <ConciergeNavButton cName={cName} fullWidth location='embedded_banner' label='Talk to your AI Budtender' />
    </Banner>
  );
}

const Banner = styled.div`
  width: 100%;
`;
